import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'

export const firebaseApp = firebase.initializeApp({
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  databaseURL: 'https://tas-server.firebaseio.com/'
})

// Get a Firestore instance
export const db = firebaseApp.firestore()

export const realtimeDB = firebase.database()

if (process.env.VUE_APP_API_BASE_URL.includes('localhost')) {
  console.log('🐊🐊🐊🐊 API URL is localhost so using emulator')
  db.useEmulator('localhost', 8080)
} else {
  console.log('🐊🐊🐊 API URL is not localhost so NOT using emulator')
}
